import { Col, Flex } from 'antd';
import styled from 'styled-components';

export const StyledCol = styled(Col)`
    margin: auto;
`;

export const StyledFlex = styled(Flex)`
    margin: auto;
`;
